<template>

    <div class="w-full h-full">

      <gmap-map
        :center="center"
        :zoom="12"
        style="width:100%;  height: 100%;"
      >
        <!-- <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          @click="center=m.position"
        ></gmap-marker> -->

        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          @click="toggleInfoWindow(m,index)">
        </gmap-marker>

        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="closeClicked"
        >
          <div v-html="infoContent"></div>
        </gmap-info-window>

      </gmap-map>
    </div>

</template>

<script>


import moment from 'moment';


export default {
    name: "GoogleMap",


    mounted() {

        // console.log(`locations are ${(JSON.stringify(this.slots))}`);

      this.loadMap();
    },

    props: {

        refreshedMap: 0,
      //not used
        highlightedLocation: {

          type: Object,
        },

        setHighlighted:{

          type: Function
        },

        dayDate: '',

        book: {
            
            type: Function
        },

        cancelBooking: {

            type: Function
        },
        
        showOnlyTheOneSlot: false,

        oneSlot:{

          type: Object
        },

        slots: {

          type: Array        
        }
    },

    components:{

    },

    data() {
        return {
          // default to Montreal to keep it simple
          // change this to whatever makes sense
          center: { lat: 29.3759, lng: 47.9774 },
          markers: [],
          infoContent: '',
          infoWindowPos: {
            lat: 0,
            lng: 0
          },
          infoWinOpen: false,
          currentMidx: null,
          //optional: offset infowindow so it visually sits nicely on top of our marker
          infoOptions: {
            pixelOffset: {
              width: 0,
              height: -35
            }
          },
        }
    },

    methods: {
        // receives a place object via the autocomplete component

        loadMap(){

          this.markers = new Array();

          if(this.showOnlyTheOneSlot){

            this.addMarker(this.oneSlot);

          }else{


            for(let i = 0; i < this.slots.length; i++){

                this.addMarker(this.slots[i], i);
            }
          }
          
        },

        closeClicked(){

          this.infoWinOpen=false;
          // this.setHighlighted(null);
        },

        setPlace(place) {
        
        // console.log(`place: ${JSON.stringify(place)}`);
        this.currentPlace = place;
        },
        
        addMarker(slot, index) {

          if(JSON.stringify(slot) ==='{}'){

            // console  .log(`in return`);
            return;
          }
            // console.log(`in return`);


          if(Object.keys(slot.class.location).length > 0);
          {

            const location = slot.class.location;

            // console.log(`location is ${JSON.stringify(location)}`);

            const marker = {
                
                lat: Number(location.latitude),
                lng: Number(location.longitude),
            };

            const minutes = ((new Date('1970/01/01 ' + slot.end_time  + '')
             - new Date('1970/01/01 ' + slot.start_time  + ''))/ (1000*60));
            const duration = moment.duration({"minutes": minutes}).humanize();

            const info = {

                index: index,
                name: slot.class.name,
                points: slot.points_cost,
                level: slot.class.level,
                available: Number(slot.capacity) - Number(slot.registered),
                startTime:slot.start_time,
                duration: duration,
                endtTime:slot.endtTime,
            };

            this.markers.push({ theSlot: slot, slotInfo: info , position: marker });

            this.center = marker;
          }
        },

        toggleInfoWindow: function (marker, idx) {
        this.infoWindowPos = marker.position;
        this.infoContent = this.getInfoWindowContent(marker);
        

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },

        getInfoWindowContent: function (marker) {

          
          const info = marker.slotInfo;

          const slot = marker.theSlot;
          
        
          this.setHighlighted(marker.theSlot, info.index);
        
        return (`<div class="flex flex-col items-between w-64 bg-blue-200">

                <div class="flex flex-row  bg-gray-100 items-center">
                    
                    <div class="flex flex-row items-center">
                            
                        <div class="flex flex-col text-center px-3 pb-6 pt-8 lg:pt-4">
    
                            <div class="flex flex-row pb-4 items-center">
                                
                                <h3 class="text-black text-sm font-extrabold font-sans" >
                                <p class="text-pink-800 pr-10 w-20">${this.$t('business.location')}</p> </h3>
                                
                                <h3 class="text-black text-sm font-extrabold font-sans" >

                                <p class="border-purple-800 border-2 lg:border-4 rounded-full text-xs lg:text-lg w-40 lg:w-64"
                                > ${slot.class.location.name} </p></h3>
                            </div>
                        </div>
                    </div>     
                </div> 
                 
                </div>`);
      },

      //   getInfoWindowContent: function (marker) {
      //   return (`<div class="card">
      //           <div class="card-image">
      //             <figure class="image is-4by3">
      //               <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
      //             </figure>
      //           </div>
      //           <div class="card-content">
      //             <div class="media">
      //               <div class="media-content">
      //                 <p class="title is-4">${marker.name}</p>
      //               </div>
      //             </div>
      //             <div class="content">
      //               ${marker.description}
      //               <br>
      //               <time datetime="2016-1-1">${marker.date_build}</time>
      //             </div>
      //           </div>
      //         </div>`);
      // },
    },


    watch: {

      'refreshedMap'(newValue) {

          this.markers = new Array();
          
          for(let i = 0; i < this.slots.length; i++){

                this.addMarker(this.slots[i], i);
          }
        },

      'dayDate'(newValue) {

          // console.log(`dayDate: ${newValue}`);
          this.loadMap();
          // this.isPinkStyle = newValue;
          },

      location: {
        handler(val){
          
        //  while(this.markers.length > 0){

        //       this.markers.pop();
          
        //   }

          if(JSON.stringify(val) ==='{}'){

          //console.log(`return`);

            return;
          } 
          
         // console.log(`location is ${Object.keys(val).length}`);

            if(Object.keys(val).length > 0);
            {

              const marker = {
                  
              lat: Number(val.latitude),
              lng: Number(val.longitude)
              };
              

              this.markers.push({ position: marker });

              // console.log(`this location is ${JSON.stringify(this.location)}`)

              this.center = marker;  
            }
                
          },

        deep: true
      }
    }
};
</script>